module.exports = __webpack_public_path__ + "static/media/marrocos.78eb9a2c.svg";